import groq from 'groq'

export const challenge = groq`
  _type,
  sideTagline,
  title,
  description,
`
